import { render, staticRenderFns } from "./Refresh.vue?vue&type=template&id=15a0f889"
import script from "./Refresh.vue?vue&type=script&lang=ts"
export * from "./Refresh.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports